/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Load: BridgeCommands.Command<
    Types.Common.Companiontool.LoadParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Load',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Save: BridgeCommands.Command<
    Types.Common.Companiontool.SaveParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Save',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Reset: BridgeCommands.Command<
    Types.Common.Companiontool.ResetParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Reset',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Run_Log_Collector: BridgeCommands.Command<
    {},
    Types.Common.Companiontool.Run_Log_CollectorReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Run_Log_Collector',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Download_Internal_Override_Tool: BridgeCommands.Command<
    {},
    Types.Common.Companiontool.Download_Internal_Override_ToolReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Download_Internal_Override_Tool',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Get_Latest_Url: BridgeCommands.Command<
    {},
    Types.Common.Companiontool.Get_Latest_UrlReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Get_Latest_Url',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Update_Internal_Override_Tool: BridgeCommands.Command<
    {},
    Types.Common.Companiontool.Update_Internal_Override_ToolReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'CompanionTool',
    method: 'Update_Internal_Override_Tool',
    persistent: false
};

export const Companiontool = {
Load,
Save,
Reset,
Run_Log_Collector,
Download_Internal_Override_Tool,
Get_Latest_Url,
Update_Internal_Override_Tool
};
